module.exports = __webpack_public_path__ + "img/loader2.9e4702bf.gif";